export const Api_Url = `https://dataapi.unizportal.com`
export const Api_Url2 = `https://dataapi2.unizportal.com`
export const Reeudo_Url = `https://exchange.unizportal.com`
export const Unizhome_Url = `https://api.unizhome.com`
export const XTravel_Url = `https://dataapi.xtravelworld.com`
